import {
  SEARCH_REQUEST_TYPE,
  SEARCH_REQUEST_TYPE_SUCCESS,
  SEARCH_REQUEST_TYPE_ERROR,
  SEARCH_EQUIPMENT_DELIVERY_ORDER,
  SEARCH_EQUIPMENT_DELIVERY_ORDER_SUCCESS,
  SEARCH_EQUIPMENT_DELIVERY_ORDER_ERROR,
  SEARCH_DELIVERY_ORDER_LINE_LOT,
  SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
  SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR,
  SEARCH_PRIORITY,
  SEARCH_PRIORITY_SUCCESS,
  SEARCH_PRIORITY_ERROR,
  SEARCH_REQUEST_STATUS,
  SEARCH_REQUEST_STATUS_SUCCESS,
  SEARCH_REQUEST_STATUS_ERROR,
  SEARCH_REQUEST_TYPE_DETAIL,
  SEARCH_REQUEST_TYPE_DETAIL_SUCCESS,
  SEARCH_REQUEST_TYPE_DETAIL_ERROR,
  SEARCH_HOSPITAL_SECTION,
  SEARCH_HOSPITAL_SECTION_SUCCESS,
  SEARCH_HOSPITAL_SECTION_ERROR,
  SEARCH_HOSPITAL_SERVICE,
  SEARCH_HOSPITAL_SERVICE_SUCCESS,
  SEARCH_HOSPITAL_SERVICE_ERROR,
  SEARCH_QUOTE_EXPIRATION,
  SEARCH_QUOTE_EXPIRATION_SUCCESS,
  SEARCH_QUOTE_EXPIRATION_ERROR,
  SEARCH_INCOTERM,
  SEARCH_INCOTERM_SUCCESS,
  SEARCH_INCOTERM_ERROR,
  SEARCH_TRANSPORT_TYPE,
  SEARCH_TRANSPORT_TYPE_SUCCESS,
  SEARCH_TRANSPORT_TYPE_ERROR,
  SEARCH_FILE_TYPE,
  SEARCH_FILE_TYPE_SUCCESS,
  SEARCH_FILE_TYPE_ERROR,
  SEARCH_REQUEST_PROCESS_TYPE,
  SEARCH_REQUEST_PROCESS_TYPE_SUCCESS,
  SEARCH_REQUEST_PROCESS_TYPE_ERROR,
  SEARCH_REQUEST_ARTICLE_TYPE,
  SEARCH_REQUEST_ARTICLE_TYPE_SUCCESS,
  SEARCH_REQUEST_ARTICLE_TYPE_ERROR,
  SEARCH_HEALTH_REGISTRY_AGENCY,
  SEARCH_HEALTH_REGISTRY_AGENCY_SUCCESS,
  SEARCH_HEALTH_REGISTRY_AGENCY_ERROR,
  SEARCH_BMP_AGENCY,
  SEARCH_BMP_AGENCY_SUCCESS,
  SEARCH_BMP_AGENCY_ERROR,
  SEARCH_RISK_TYPE,
  SEARCH_RISK_TYPE_SUCCESS,
  SEARCH_RISK_TYPE_ERROR,
  SEARCH_GHTF,
  SEARCH_GHTF_SUCCESS,
  SEARCH_GHTF_ERROR,
  SEARCH_DIAGNOSTIC_CLASS,
  SEARCH_DIAGNOSTIC_CLASS_SUCCESS,
  SEARCH_DIAGNOSTIC_CLASS_ERROR,
  SEARCH_ISO,
  SEARCH_ISO_SUCCESS,
  SEARCH_ISO_ERROR,
  SEARCH_GT_CERTIFICATE,
  SEARCH_GT_CERTIFICATE_SUCCESS,
  SEARCH_GT_CERTIFICATE_ERROR,
  SEARCH_SERVICE_TYPE,
  SEARCH_SERVICE_TYPE_SUCCESS,
  SEARCH_SERVICE_TYPE_ERROR,
  SEARCH_BIOEQUIVALENCE,
  SEARCH_BIOEQUIVALENCE_SUCCESS,
  SEARCH_BIOEQUIVALENCE_ERROR
} from '../actions';
 
const INIT_STATE = {
  modal: false,
  init:true,
  request_type: {
    data: [],
    loading: true,
    message: ''
  },
  equipment_delivery_order: {
    data: [],
    loading: true,
    message: ''
  },
  delivery_order_line_lot: {
    data: [],
    loading: true,
    message: ''
  },
  priority: {
    data: [],
    loading: true,
    message: ''
  },
  request_status: {
    data: [],
    loading: true,
    message: ''
  },
  hospital_section: {
    data: [],
    loading: true,
    message: ''
  },
  request_type_detail: {
    data: [],
    loading: true,
    message: ''
  },
  hospital_service: {
    data: [],
    loading: true,
    message: ''
  },
  quote_expiration: {
    data: [],
    loading: true,
    message: ''
  },
  incoterm: {
    data: [],
    loading: true,
    message: ''
  },
  transport_type: {
    data: [],
    loading: true,
    message: ''
  },
  file_type: {
    data: [],
    loading: true,
    message: ''
  },
  request_process_type: {
    data: [],
    loading: true,
    message: ''
  },
  request_article_type: {
    data: [],
    loading: true,
    message: ''
  },
  health_registry_agency: {
    data: [],
    loading: true,
    message: ''
  },
  bmc_agency: {
    data: [],
    loading: true,
    message: ''
  },
  risk_type: {
    data: [],
    loading: true,
    message: ''
  },
  ghtf: {
    data: [],
    loading: true,
    message: ''
  },
  diagnostic_class: {
    data: [],
    loading: true,
    message: ''
  },
  iso: {
    data: [],
    loading: true,
    message: ''
  },
  gt_certificate: {
    data: [],
    loading: true,
    message: ''
  },
  service_type: {
    data: [],
    loading: true,
    message: ''
  },
  bioequivalence: {
    data: [],
    loading: true,
    message: ''
  },
  value:{
    quote_expiration: false,
    request_type: false,
    equipment_delivery_order: false,
    delivery_order_line_lot: false,
    priority: false,
    request_status: false, 
    hospital_section: false,
    request_type_detail: false,
    hospital_service: false,
    incoterm: false,
    transport_type: false,
    file_type: false,
    request_process_type: false,
    risk_type: false,
    ghtf: false,
    diagnostic_class: false,
    iso: false,
    service_type: false,
    priority:'Si',
    code: '',
    request_article_type: '',
    health_registry_agency: '',
    bmc_agency: '',
    gt_certificate: false,
    bioequivalence: false,
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SEARCH_REQUEST_TYPE:
      return {
        ...state,
        init:false,
        request_type:{
          ...state.request_type,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_REQUEST_TYPE_SUCCESS:
      return {
        ...state,
        request_type:{
          ...state.request_type,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_REQUEST_TYPE_ERROR:
      return {
        ...state,
        request_type:{
          ...state.request_type,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_EQUIPMENT_DELIVERY_ORDER:
      return {
        ...state,
        init:false,
        equipment_delivery_order:{
          ...state.equipment_delivery_order,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_EQUIPMENT_DELIVERY_ORDER_SUCCESS:
      return {
        ...state,
        equipment_delivery_order:{
          ...state.equipment_delivery_order,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_EQUIPMENT_DELIVERY_ORDER_ERROR:
      return {
        ...state,
        equipment_delivery_order:{
          ...state.equipment_delivery_order,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_DELIVERY_ORDER_LINE_LOT:
      return {
        ...state,
        init:false,
        delivery_order_line_lot:{
          ...state.delivery_order_line_lot,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS:
      return {
        ...state,
        delivery_order_line_lot:{
          ...state.delivery_order_line_lot,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR:
      return {
        ...state,
        delivery_order_line_lot:{
          ...state.delivery_order_line_lot,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_PRIORITY:
      return {
        ...state,
        init:false,
        priority:{
          ...state.priority,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_PRIORITY_SUCCESS:
      return {
        ...state,
        priority:{
          ...state.priority,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_PRIORITY_ERROR:
      return {
        ...state,
        priority:{
          ...state.priority,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_REQUEST_STATUS:
      return {
        ...state,
        init:false,
        request_status:{
          ...state.request_status,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_REQUEST_STATUS_SUCCESS:
      return {
        ...state,
        request_status:{
          ...state.request_status,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_REQUEST_STATUS_ERROR:
      return {
        ...state,
        request_status:{
          ...state.request_status,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_REQUEST_TYPE_DETAIL:
      return {
        ...state,
        init:false,
        request_type_detail:{
          ...state.request_type_detail,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_REQUEST_TYPE_DETAIL_SUCCESS:
      return {
        ...state,
        request_type_detail:{
          ...state.request_type_detail,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_REQUEST_TYPE_DETAIL_ERROR:
      return {
        ...state,
        request_type_detail:{
          ...state.request_type_detail,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_HOSPITAL_SECTION:
      return {
        ...state,
        init:false,
        hospital_section:{
          ...state.hospital_section,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_HOSPITAL_SECTION_SUCCESS:
      return {
        ...state,
        hospital_section:{
          ...state.hospital_section,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_HOSPITAL_SECTION_ERROR:
      return {
        ...state,
        hospital_section:{
          ...state.hospital_section,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_HOSPITAL_SERVICE:
      return {
        ...state,
        init:false,
        hospital_service:{
          ...state.hospital_service,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_HOSPITAL_SERVICE_SUCCESS:
      return {
        ...state,
        hospital_service:{
          ...state.hospital_service,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_HOSPITAL_SERVICE_ERROR:
      return {
        ...state,
        hospital_service:{
          ...state.hospital_service,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_QUOTE_EXPIRATION:
      return {
        ...state,
        init:false,
        quote_expiration:{
          ...state.quote_expiration,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_QUOTE_EXPIRATION_SUCCESS:
      return {
        ...state,
        quote_expiration:{
          ...state.quote_expiration,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_QUOTE_EXPIRATION_ERROR:
      return {
        ...state,
        quote_expiration:{
          ...state.quote_expiration,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_INCOTERM:
      return {
        ...state,
        init:false,
        incoterm:{
          ...state.quote_expiration,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_INCOTERM_SUCCESS:
      return {
        ...state,
        incoterm:{
          ...state.incoterm,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_INCOTERM_ERROR:
      return {
        ...state,
        incoterm:{
          ...state.incoterm,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_TRANSPORT_TYPE:
      return {
        ...state,
        init:false,
        transport_type:{
          ...state.transport_type,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_TRANSPORT_TYPE_SUCCESS:
      return {
        ...state,
        transport_type:{
          ...state.transport_type,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_TRANSPORT_TYPE_ERROR:
      return {
        ...state,
        transport_type:{
          ...state.transport_type,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_FILE_TYPE:
      return {
        ...state,
        init:false,
        file_type:{
          ...state.file_type,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_FILE_TYPE_SUCCESS:
      return {
        ...state,
        file_type:{
          ...state.file_type,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_FILE_TYPE_ERROR:
      return {
        ...state,
        file_type:{
          ...state.file_type,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_REQUEST_PROCESS_TYPE:
      return {
        ...state,
        init:false,
        request_process_type:{
          ...state.request_process_type,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_REQUEST_PROCESS_TYPE_SUCCESS:
      return {
        ...state,
        request_process_type:{
          ...state.request_process_type,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_REQUEST_PROCESS_TYPE_ERROR:
      return {
        ...state,
        request_process_type:{
          ...state.request_process_type,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_REQUEST_ARTICLE_TYPE:
      return {
        ...state,
        init:false,
        request_article_type:{
          ...state.request_article_type,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_REQUEST_ARTICLE_TYPE_SUCCESS:
      return {
        ...state,
        request_article_type:{
          ...state.request_article_type,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_REQUEST_ARTICLE_TYPE_ERROR:
      return {
        ...state,
        request_article_type:{
          ...state.request_article_type,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_HEALTH_REGISTRY_AGENCY:
      return {
        ...state,
        init:false,
        health_registry_agency:{
          ...state.health_registry_agency,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_HEALTH_REGISTRY_AGENCY_SUCCESS:
      return {
        ...state,
        health_registry_agency:{
          ...state.health_registry_agency,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_HEALTH_REGISTRY_AGENCY_ERROR:
      return {
        ...state,
        health_registry_agency:{
          ...state.health_registry_agency,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }

    case SEARCH_BMP_AGENCY:
      return {
        ...state,
        init:false,
        bmp_agency:{
          ...state.bmp_agency,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_BMP_AGENCY_SUCCESS:
      return {
        ...state,
        bmp_agency:{
          ...state.bmp_agency,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_BMP_AGENCY_ERROR:
      return {
        ...state,
        bmp_agency:{
          ...state.bmp_agency,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_RISK_TYPE:
      return {
        ...state,
        init:false,
        risk_type:{
          ...state.risk_type,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_RISK_TYPE_SUCCESS:
      return {
        ...state,
        risk_type:{
          ...state.risk_type,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_RISK_TYPE_ERROR:
      return {
        ...state,
        risk_type:{
          ...state.risk_type,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_GHTF:
      return {
        ...state,
        init:false,
        ghtf:{
          ...state.ghtf,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_GHTF_SUCCESS:
      return {
        ...state,
        ghtf:{
          ...state.ghtf,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_GHTF_ERROR:
      return {
        ...state,
        ghtf:{
          ...state.ghtf,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_DIAGNOSTIC_CLASS:
      return {
        ...state,
        init:false,
        diagnostic_class:{
          ...state.diagnostic_class,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_DIAGNOSTIC_CLASS_SUCCESS:
      return {
        ...state,
        diagnostic_class:{
          ...state.diagnostic_class,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_DIAGNOSTIC_CLASS_ERROR:
      return {
        ...state,
        diagnostic_class:{
          ...state.diagnostic_class,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_ISO:
      return {
        ...state,
        init:false,
        iso:{
          ...state.iso,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_ISO_SUCCESS:
      return {
        ...state,
        iso:{
          ...state.iso,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_ISO_ERROR:
      return {
        ...state,
        iso:{
          ...state.iso,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_GT_CERTIFICATE:
      return {
        ...state,
        init:false,
        gt_certificate:{
          ...state.gt_certificate,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_GT_CERTIFICATE_SUCCESS:
      return {
        ...state,
        gt_certificate:{
          ...state.gt_certificate,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_GT_CERTIFICATE_ERROR:
      return {
        ...state,
        gt_certificate:{
          ...state.gt_certificate,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_SERVICE_TYPE:
      return {
        ...state,
        init:false,
        service_type:{
          ...state.service_type,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_SERVICE_TYPE_SUCCESS:
      return {
        ...state,
        service_type:{
          ...state.service_type,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_SERVICE_TYPE_ERROR:
      return {
        ...state,
        service_type:{
          ...state.service_type,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_BIOEQUIVALENCE:
      return {
        ...state,
        init:false,
        bioequivalence:{
          ...state.bioequivalence,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_BIOEQUIVALENCE_SUCCESS:
      return {
        ...state,
        bioequivalence:{
          ...state.bioequivalence,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_BIOEQUIVALENCE_ERROR:
      return {
        ...state,
        bioequivalence:{
          ...state.bioequivalence,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    default:
      return { ...state };
  }
};